import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import './modal.css';
import ButtonModal from './ButtonModal';

class Modal extends Component{
    render(){
      const {titulo, contenido, contenido2, contenido3, funcion, imgModal, isOpen, textBtnModal, css} = this.props;
      if(!isOpen) return null;
      return ReactDOM.createPortal(
        <div className={`Modal ${!css? '':css}`}>
          <div className="Modal__container">
            <div className="container modal">
              <div className="row">
                <div className="col">
                  <img src={imgModal} className="iconModal" alt="svg" />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h2 className="titleModal">{titulo}</h2>
                  <p>{contenido}</p>
                  <p>{contenido2}</p>
                  <p className="small">{contenido3}</p>
                  <ButtonModal
                    buttonName={textBtnModal}
                    callFunction={funcion}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>, 
       document.getElementById('Modal')
      )
    }
}

export default Modal;